module.exports = __webpack_public_path__ + "static/media/emptyState.25008ae3.png";